import type { RouteObject } from 'react-router';
import { handle } from '@/app/router/handle';

/** /help */
export const helpRoutes: RouteObject = {
  path: 'help',
  handle: handle('helpAndSupport'),
  lazy: () => import('./HelpPage').then((m) => ({ Component: m.HelpPage })),
};
